import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import {
  clearInventoryCategoriesList,
  deleteInventoryCategory,
  getInventoryCategories,
} from 'features/inventory/invSettingsCategoriesSlice'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Flex,
  GridItem,
  ItemsGrid,
  MainHeadline,
  PageFooter,
  PageWrapper,
} from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'
import { Button } from 'components/ui/Button/Button'
import { getParams, handlePagination } from 'utils/helpers'
import { ISingleInventoryCategory } from 'types/inventory.interface'
import useQueryPagination from 'hooks/useQueryPagination'
import { AppDispatch, RootState } from 'store'
import { IInventoryCategoryModal, InventoryCategoryModal } from './InventoryCategoryModal'
import { costingMethodOptions, trackingModeOptions } from '../Items/itemsData'
import { IGetAllInventoryCategoriesSingleRespone } from 'types/api/categoriesApi.interface'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { setConfirmModal } from 'features/global/globalSlice'
import { ModalTypes } from 'types/global.interface'

export const InventoryCategories = () => {
  const [modal, setModal] = useState({ open: false, value: null, sub: false })
  const { inventoryCategories, totalPages } = useSelector(
    (state: RootState) => state.inventoryCategories,
  )
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location }))
  const dispatch = useDispatch<AppDispatch>()

  const removeCategory = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteInventoryCategory({ id }))
        },
        setParams: {
          type: ModalTypes.Delete
        },
        word: 'delete category',
      }),
    )
  }

  useQueryPagination({ fetchFunctions: [getInventoryCategories], cleanUpFunctions: [clearInventoryCategoriesList], params })


  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Inventory Categories...' setParams={setParams} />
      <PageWrapper>
        <Flex between center mb='16' >
          <Flex column gap='0.25rem'>
            <MainHeadline>Inventory Categories</MainHeadline>
            <OtherText grey>Category tree with tracking and costing defaults</OtherText>
          </Flex>
          <Button variant='primary' onClick={() => setModal({ open: true, value: null, sub: false })}>
            Add Category
          </Button>
        </Flex>
        <ItemsGrid columns={3}>
          {!inventoryCategories.length ? (
            <NoItems title='Inventory categories' />
          ) : (
            inventoryCategories.map(({ name, id }: IGetAllInventoryCategoriesSingleRespone) => {
              return (
                <GridItem key={id}>
                  <p onClick={() => navigate('/inventory-categories/' + id.toString())}>{name}</p>

                  <Flex between center onClick={() => removeCategory(id)}>
                    <RemoveCircle />
                  </Flex>
                </GridItem>
              )
            })
          )}
        </ItemsGrid>

        {modal.open && (
          <InventoryCategoryModal subcategory={modal.sub} closeModal={() => setModal({ open: false, value: null, sub: false })} />
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}

export const convertToInvCategoriesModalData = (data: ISingleInventoryCategory): IInventoryCategoryModal => {
  return {
    id: data.id,
    name: data.name,
    parent: data.parent ? { label: data.parent.name, value: data.parent.id } : null,
    defaultTrackingMode: data.defaultTrackingMode ? trackingModeOptions.find(m => m.value == data.defaultTrackingMode) : null,
    defaultCostingMethod: data.defaultCostingMethod ? costingMethodOptions.find(c => c.value == data.defaultCostingMethod) : null,
    fields: data.fields.map(f => ({ label: f.field.label, value: f.field.id }))
  }
}
